import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  updateProfile,
  sendEmailVerification
} from "firebase/auth";
import { auth, storage, db } from "../firebase";
import { getDownloadURL, ref } from "firebase/storage";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

export default function Signup() {
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/host";

  const [bgUrl, setBgUrl] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const linkStyle = {
    color: "#9fe8ff",
    textDecoration: "underline",
    textUnderlineOffset: 3,
    fontWeight: 700,
    outline: "none",
  };

  useEffect(() => {
    getDownloadURL(ref(storage, "media/Brainbackground.png")).then(setBgUrl);
  }, []);

  async function ensureUserDoc(uid, emailAddr) {
    const userRef = doc(db, "users", uid);
    const snap = await getDoc(userRef);
    if (!snap.exists()) {
      await setDoc(userRef, {
        email: emailAddr,
        displayName: name || emailAddr.split("@")[0],
        role: "Quiz Host",
        createdAt: serverTimestamp(),
        lastLogin: serverTimestamp(),
        entitlements: {
          subscriptionStatus: "none",
          weeklyQuantity: 0,
          quizTokens: 0
        }
      });
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { user } = await createUserWithEmailAndPassword(auth, email.trim(), password);
      if (name.trim()) await updateProfile(user, { displayName: name.trim() });
      try { await sendEmailVerification(user); } catch {}
      await ensureUserDoc(user.uid, user.email || email.trim());
      nav(next, { replace: true }); // go to /host by default
    } catch (ex) {
      setError(ex?.message || "Could not create account");
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        background: bgUrl
          ? `linear-gradient(rgba(24,24,40,0.72), rgba(44,16,50,0.87)), url(${bgUrl}) center center / cover no-repeat`
          : "#223b4c",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        fontFamily: "'Montserrat', 'Open Sans', Arial, sans-serif"
      }}
    >
      <div
        className="quiz-navbar"
        style={{
          width: "100vw",
          padding: "20px 0 12px 0",
          background: "rgba(20,15,44,0.55)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "38px",
          position: "sticky",
          top: 0,
          zIndex: 999
        }}
      >
        <span style={{
          color: "#e8f6ff",
          fontWeight: 900,
          fontSize: "1.24em",
          letterSpacing: 0.6,
          padding: "6px 18px",
          textShadow: "2px 2px 16px #0097ff, 0 2px 12px #2ae, 0 4px 16px #193b",
          filter: "drop-shadow(0 1.5px 10px #00d4ff66)"
        }}>
          Create Quizmaster Account
        </span>
      </div>

      <form
        onSubmit={onSubmit}
        style={{
          marginTop: "7vh",
          background: "rgba(28,34,58,0.67)",
          boxShadow: "0 8px 36px 8px #111b, 0 1.5px 12px #2ae8",
          borderRadius: "2.2em",
          padding: "2.2em 2.5em 2.2em 2.5em",
          maxWidth: 420,
          width: "94vw",
          minHeight: 240,
          backdropFilter: "blur(18px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#f6fcff"
        }}
      >
        <div style={{
          fontWeight: 900,
          fontSize: "2.0em",
          letterSpacing: 0.4,
          color: "#e2eefd",
          textShadow: "2px 2px 14px #2ae, 0 2px 12px #09f, 0 4px 16px #222c",
          marginBottom: 30,
        }}>
          Create Account
        </div>

        <input
          type="text"
          placeholder="Your name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{
            width: "100%",
            fontSize: "1.10em",
            marginBottom: 18,
            borderRadius: "1.1em",
            padding: "15px 18px",
            border: "2.2px solid #8cd4ff",
            background: "rgba(40,65,110,0.13)",
            fontWeight: 600,
            color: "#e8f4ff",
            boxShadow: "0 2px 8px #2ae2, 0 1.5px 6px #223b",
            outline: "none"
          }}
        />
        <input
          type="email"
          placeholder="Email address"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: "100%",
            fontSize: "1.10em",
            marginBottom: 18,
            borderRadius: "1.1em",
            padding: "15px 18px",
            border: "2.2px solid #8cd4ff",
            background: "rgba(40,65,110,0.13)",
            fontWeight: 600,
            color: "#e8f4ff",
            boxShadow: "0 2px 8px #2ae2, 0 1.5px 6px #223b",
            outline: "none"
          }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          required
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%",
            fontSize: "1.10em",
            marginBottom: 26,
            borderRadius: "1.1em",
            padding: "15px 18px",
            border: "2.2px solid #8cd4ff",
            background: "rgba(40,65,110,0.13)",
            fontWeight: 600,
            color: "#e8f4ff",
            boxShadow: "0 2px 8px #2ae2, 0 1.5px 6px #223b",
            outline: "none"
          }}
        />

        {error && (
          <div style={{
            color: "#ffaaaa",
            background: "rgba(46,6,6,0.16)",
            fontWeight: 700,
            fontSize: "1.12em",
            marginBottom: 12,
            padding: "7px 0",
            borderRadius: "0.6em",
            width: "100%",
            textAlign: "center",
            textShadow: "0 2px 12px #0009"
          }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={busy}
          style={{
            background: "linear-gradient(135deg, #ffe066 0%, #47e373 100%)",
            color: "#273b44",
            fontWeight: 900,
            borderRadius: "2em",
            fontSize: "1.15em",
            padding: "0.78em 3.2em",
            border: "none",
            boxShadow: "0 4px 14px #0003, 0 1px 8px #ffe06677",
            cursor: busy ? "default" : "pointer",
            letterSpacing: 0.06,
            marginTop: "0.4em",
            transition: "background 0.13s",
            opacity: busy ? 0.7 : 1
          }}
        >
          {busy ? "Creating…" : "Create Account"}
        </button>

        <p style={{ marginTop: 12 }}>
          Already have an account?{" "}
          <Link to="/login" style={linkStyle}>
            Sign in
          </Link>
        </p>
      </form>
    </div>
  );
}
